import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

interface ResponsiveContextValue {
  width: number;
  isPhone: boolean;
  isMobileShell: boolean;
  isDesktop: boolean;
}

const ResponsiveContext = createContext<ResponsiveContextValue>({
  width: 1440,
  isPhone: false,
  isMobileShell: false,
  isDesktop: true,
});

const getViewportWidth = () => {
  if (typeof window === 'undefined') return 1440;
  return window.innerWidth;
};

export const ResponsiveProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [width, setWidth] = useState<number>(getViewportWidth);

  useEffect(() => {
    const handleResize = () => setWidth(getViewportWidth());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const value = useMemo<ResponsiveContextValue>(() => ({
    width,
    isPhone: width <= 768,
    isMobileShell: width <= 1024,
    isDesktop: width > 1024,
  }), [width]);

  return (
    <ResponsiveContext.Provider value={value}>
      {children}
    </ResponsiveContext.Provider>
  );
};

export const useResponsive = () => useContext(ResponsiveContext);

export default ResponsiveContext;
